import React from 'react'

const flexValueTable = {
    heading:[
        {
            head:"ID"
        },
        {
            head:"Flex Value"
        },
        {
            head:"Flex Short Value"
        },
        {
            head:"Attribute1"
        },
        {
            head:"Attribute2"
        },
        {
            head:"Attribute3"
        },
        {
            head:"Attribute4"
        },
        {
            head:"Attribute5"
        },
        {
            head:"Action"
        }
    ],
    data:[
        {
            id:"258",
            flexvalue:"NORMAL",
            flexshortvalue:"Normal",
            attribute1:"Islam",
            attribute2:"Islam",
            attribute3:"Islam",
            attribute4:"Islam",
            attribute5:"Islam",
            activefrom:"2023-04-02",
            activeto:"2023-04-05",
            action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
        },
       
    ]
}

const FlexValue = () => {
  return (
    <></>
  )
}


export {flexValueTable}

export default FlexValue